import { useState, type FormEvent } from "react";

export type FormStatus = "idle" | "loading" | "success" | "error";

type ParsedResponse = {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
};

export const useFormSubmit = (submitAddr: string, honeypotName: string) => {
  const [status, setStatus] = useState<FormStatus>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const trapRaw = formData.get(honeypotName);
    const trapValue = typeof trapRaw === "string" ? trapRaw.trim() : "";
    if (trapValue) {
      setStatus("success");
      setMessage("提交成功，感谢你的参与。");
      form.reset();
      return;
    }
    formData.delete(honeypotName);

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (typeof value === "string" && value.trim() !== "") {
        params.append(key, value);
      }
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: ParsedResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as ParsedResponse;
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const code = parsed?.code;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && code === "OK" && !isSpam) {
        setStatus("success");
        setMessage(serverMsg || "提交成功，我们会尽快与你联系。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后重试。");
      }
    } catch (error) {
      setStatus("error");
      setMessage(error instanceof Error ? error.message : "网络异常，请稍后重试。");
    }
  };

  return { status, message, handleSubmit };
};